import $ from 'jquery';

$(function () {
    const carouselContainer = $('.membership-card-wrapper .carousel-container');
    let currentIndex = carouselContainer.data('currentIndex') || 0;

    function initializeCarousel() {
        const slides = carouselContainer.find('.carousel-slide');
        const indicatorsContainer = carouselContainer.find('#carousel-indicators');
        const slider = carouselContainer.find('.carousel-slider');

        // Clear existing indicators to prevent duplication
        indicatorsContainer.empty();

        // Handle single slide layout differently
        if (slides.length === 1) {
            carouselContainer.addClass('single-slide');
        } else {
            slides.each(function (index) {
                const indicator = $('<div class="indicator"></div>');
                if (index === currentIndex) {
                    indicator.addClass('active');
                }
                indicatorsContainer.append(indicator);
            });
        }

        // Cache indicators after generation
        const indicators = indicatorsContainer.find('.indicator');

        // Core slide display function
        function showSlide(index) {
            currentIndex = index;
            carouselContainer.data('currentIndex', currentIndex);
            
            // Calculate slide position
            const slideWidth = slides.eq(0).outerWidth(true);
            const offset = -index * slideWidth;
            
            // Apply transform with smooth transition
            slider.css({
                'transition': 'transform 0.3s ease-out',
                'transform': `translateX(${offset}px)`
            });
            
            // Update indicator states
            indicators.removeClass('active')
                     .eq(index)
                     .addClass('active');
        }

        // Next button click handler
        carouselContainer.find('.next').off('click').on('click', function (e) {
            e.preventDefault();
            showSlide((currentIndex + 1) % slides.length);
        });

        // Previous button click handler
        carouselContainer.find('.prev').off('click').on('click', function (e) {
            e.preventDefault();
            showSlide((currentIndex - 1 + slides.length) % slides.length);
        });

        // Indicator click handler
        indicators.off('click').on('click', function () {
            showSlide($(this).index());
        });

        // Touch event variables
        let startX = 0;
        let isDragging = false;
        let slideWidth;

        // Touch start handler
        carouselContainer.off('touchstart').on('touchstart', function (e) {
            const touch = e.originalEvent.touches[0];
            const target = $(touch.target);

            // Ignore drag on interactive elements
            if (target.is('a, .indicator, .prev, .next') || 
                target.closest('a, .prev, .next').length) {
                return;
            }

            // Initialize drag values
            startX = touch.clientX;
            isDragging = true;
            
            // Get fresh slide width measurement
            slideWidth = slides.eq(0).outerWidth(true);
            
            // Disable transitions during drag
            slider.css('transition', 'none');
        });

        // Touch move handler
        carouselContainer.off('touchmove').on('touchmove', function (e) {
            if (!isDragging) return;
            
            // Calculate drag offset
            const currentX = e.originalEvent.touches[0].clientX;
            const diffX = currentX - startX;
            
            // Update slider position in real-time
            slider.css('transform', `translateX(${diffX - currentIndex * slideWidth}px)`);
        });

        // Touch end handler
        carouselContainer.off('touchend').on('touchend', function () {
            if (!isDragging) return;
            isDragging = false;

            // Get final transform matrix values
            const finalTransform = slider.css('transform');
            const matrix = new DOMMatrix(finalTransform);
            
            // Calculate actual slide position
            const actualOffset = Math.round(matrix.m41 / slideWidth) * -1;
            
            // Clamp index to valid range
            let newIndex = Math.min(
                Math.max(actualOffset, 0),
                slides.length - 1
            );
            
            // Update to final slide position
            showSlide(newIndex);
        });
    }

    // Initial carousel setup
    initializeCarousel();

    // Popup open handler
    $('.popup-open').on('click', function () {
        carouselContainer.data('isPopupOpen', true);
    });

    // Popup close handler (critical fix area)
    $('.popup-close').on('click', function () {
        // Store previous state before reinitialization
        const prevIndex = currentIndex;
        
        // Reinitialize with fresh DOM references
        initializeCarousel();
        
        // Get updated slide measurements
        const slides = carouselContainer.find('.carousel-slide');
        const slider = carouselContainer.find('.carousel-slider');
        const slideWidth = slides.eq(0).outerWidth(true);

        // Immediately apply correct position without transition
        slider.css({
            'transform': `translateX(${-prevIndex * slideWidth}px)`,
            'transition': 'none'
        });
        
        // Force synchronous layout update
        slider.get(0).offsetHeight;
        
        // Restore transitions
        slider.css('transition', '');
        
        // Update indicators to match position
        showSlide(prevIndex);
    });

    // Modal closed handler
    $(document).on('modalClosed', function () {
        initializeCarousel();
    });
});


// WEBPACK FOOTER //
// ./components/cw-membership-slider/scripts/membership-slider.js